import { useEffect } from "react";
import { useGoogleReCaptchaVisibleToggle, useGoogleReCaptcha } from "@dpdgroupuk/react-google-recaptcha-v3";
import { useKeyboardOpened } from "../../hooks";
export const useEnhancedReCaptchaBadge = () => {
  useGoogleReCaptchaVisibleToggle();
  const isKeyboardActive = useKeyboardOpened();
  const {
    setVisibility
  } = useGoogleReCaptcha();
  const visibility = isKeyboardActive ? "hidden" : "visible";
  useEffect(() => {
    setVisibility(visibility);
  });
};